import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGIN_RESET,
  LOGOUT,
  SET_USER,
  INITIALIZE_AUTH,
} from '../actions/loginAction';
import { STORAGE_KEYS } from '../../utils/constants';

const initialState = {
  apiState: '',
  message: '',
  data: null,
  error: '',
  user: null,
  token: null,
  refreshToken: null,
  isAuthenticated: false,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        apiState: 'loading',
      };
    case LOGIN_SUCCESS:
      // Store tokens and user data if status is 1
      if (action.response.status === 1 && action.response.data) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, action.response.data.accessToken);
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, action.response.data.refreshToken);
        localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(action.response.data.user));
        if (action.response.data.expiresAt) {
          localStorage.setItem('expiresAt', action.response.data.expiresAt);
        }
        if (action.response.data.permissions) {
          localStorage.setItem(STORAGE_KEYS.PERMISSIONS, JSON.stringify(action.response.data.permissions));
        }
      }
      return {
        ...state,
        apiState: 'success',
        data: action.response.data || action.response,
        user: action.response.data?.user || null,
        token: action.response.data?.accessToken || null,
        refreshToken: action.response.data?.refreshToken || null,
        isAuthenticated: true,
        message: action.response.message || 'success',
        error: '',
      };
    case LOGIN_FAIL:
      return {
        ...state,
        apiState: 'error',
        data: action.response,
        error: action.response.errors || null,
        message: action.response.message || 'error',
        isAuthenticated: false,
      };
    case LOGIN_RESET:
      return initialState;
    case LOGOUT:
      return {
        ...initialState,
        apiState: '',
      };
    case SET_USER:
      return {
        ...state,
        user: action.user,
      };
    case INITIALIZE_AUTH:
      const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      const userData = localStorage.getItem(STORAGE_KEYS.USER_DATA);
      if (token && userData) {
        return {
          ...state,
          token,
          user: JSON.parse(userData),
          isAuthenticated: true,
        };
      }
      return state;
    default:
      return state;
  }
};

export default loginReducer;

